import { useState, useEffect } from "react";
import { EligibleWithdrawal } from "@/types/adminPayout";
import AdminPayoutServices from "@/services/adminPayoutServices";
import { getGlobalSessionId } from "@/services";

const useEligibleWithdrawals = () => {
  const [eligibleWithdrawals, setEligibleWithdrawals] = useState<
    EligibleWithdrawal[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchEligibleWithdrawals = async () => {
    const sessionId = getGlobalSessionId();
    if (!sessionId) {
      console.warn("No session ID available for admin payout");
      return;
    }

    setIsLoading(true);
    setIsError(false);

    try {
      const data = await AdminPayoutServices.getEligibleUsers(sessionId);
      setEligibleWithdrawals(data);
    } catch (error) {
      console.error("Failed to fetch eligible withdrawals:", error);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEligibleWithdrawals();
  }, []);

  const refetch = () => {
    fetchEligibleWithdrawals();
  };

  return {
    eligibleWithdrawals,
    isLoading,
    isError,
    refetch,
  };
};

export default useEligibleWithdrawals;
